import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e3d217c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "info-bar",
  class: "d-flex justify-content-center position-fixed bg-darky w-100"
}

import {ref, watch} from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  message: {
    type: String,
    default() {
      return ""
    }
  }
},
  emits: ["hidden"],
  setup(__props, { emit }: { emit: ({
  (e: 'hidden'):void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const show = ref<boolean>(false)
let hideTimeout = -1

watch(() => props.message, (val:string) => {
  if (!val || val === "") {
    return
  }
  if (hideTimeout != -1) {
     clearTimeout(hideTimeout)
  }
  show.value = true
  hideTimeout = setTimeout(() => { show.value = false, emit('hidden')}, 5000)
})

return (_ctx: any,_cache: any) => {
  return (show.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.message), 1))
    : _createCommentVNode("", true)
}
}

})